import createIcon from '../../createIcon';

/**
 * @component @name Twentytwomp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiAxOC41SDEwLjVWMTRIOS41VjE3SDhWMTRIN1YxOC41SDUuNVYxMy41QzUuNSAxMi45NSA1Ljk1IDEyLjUgNi41IDEyLjVIMTFDMTEuNTUgMTIuNSAxMiAxMi45NSAxMiAxMy41VjE4LjVaTTE1LjUgMTguNUgxNFYxMi41SDE3LjVDMTguMDUgMTIuNSAxOC41IDEyLjk1IDE4LjUgMTMuNVYxNkMxOC41IDE2LjU1IDE4LjA1IDE3IDE3LjUgMTdIMTUuNVYxOC41Wk0xMCA5SDhWMTBIMTFWMTEuNUg2LjVWOUM2LjUgOC40NSA2Ljk1IDggNy41IDhIOS41VjdINi41VjUuNUgxMEMxMC41NSA1LjUgMTEgNS45NSAxMSA2LjVWOEMxMSA4LjU1IDEwLjU1IDkgMTAgOVpNMTYuNSA5SDE0LjVWMTBIMTcuNVYxMS41SDEzVjlDMTMgOC40NSAxMy40NSA4IDE0IDhIMTZWN0gxM1Y1LjVIMTYuNUMxNy4wNSA1LjUgMTcuNSA1Ljk1IDE3LjUgNi41VjhDMTcuNSA4LjU1IDE3LjA1IDkgMTYuNSA5Wk0xNS41IDE0SDE3VjE1LjVIMTUuNVYxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Twentytwomp = createIcon('Twentytwomp', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18.5H10.5V14H9.5V17H8V14H7V18.5H5.5V13.5C5.5 12.95 5.95 12.5 6.5 12.5H11C11.55 12.5 12 12.95 12 13.5V18.5ZM15.5 18.5H14V12.5H17.5C18.05 12.5 18.5 12.95 18.5 13.5V16C18.5 16.55 18.05 17 17.5 17H15.5V18.5ZM10 9H8V10H11V11.5H6.5V9C6.5 8.45 6.95 8 7.5 8H9.5V7H6.5V5.5H10C10.55 5.5 11 5.95 11 6.5V8C11 8.55 10.55 9 10 9ZM16.5 9H14.5V10H17.5V11.5H13V9C13 8.45 13.45 8 14 8H16V7H13V5.5H16.5C17.05 5.5 17.5 5.95 17.5 6.5V8C17.5 8.55 17.05 9 16.5 9ZM15.5 14H17V15.5H15.5V14Z',
      key: '1vlchn',
    },
  ],
]);

export default Twentytwomp;
